import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { CurrentUserState, currentUserStore } from "../stores/currentUserStore";

export const useCurrentUser = (): CurrentUserState =>
  useStore(
    currentUserStore,
    useShallow(({ actions: _, ...currentUser }) => currentUser)
  );
